import { useRouter } from 'next/router';

import { setCurrentLocation } from 'actions';
import { useMetrics } from 'integrations/metrics';
import { EventReferrers } from 'integrations/metrics/events';
import { ParsedUrlQuery } from 'querystring';

import { TApplicationContext } from 'types/app-context';

import { initMoment } from 'utils/initMoment';

export const getReferrer = (
  query: ParsedUrlQuery,
): EventReferrers | undefined => {
  if (query.rwg_token) {
    return EventReferrers.RWG;
  }

  if (query.ref === 'rr') {
    return EventReferrers.RR;
  }

  return undefined;
};

export const useAppInit = (context: TApplicationContext) => {
  const { publicUser, theme } = context || {};

  // set the location
  const router = useRouter();

  context?.store?.dispatch(setCurrentLocation({ path: router.pathname }));

  // initialize moment
  initMoment(publicUser?.preferences?.timezone);

  // initialize segment
  useMetrics(
    publicUser?.owner_guid,
    publicUser?.guid,
    theme?.name,
    getReferrer(router.query),
  );
};
